import { MonthlyProductionChart } from "./MonthlyProductionChart";
export default MonthlyProductionChart;
